import { useCurrentPatient, useIsVerified } from '@/modules/userConfig';
import { useDialog } from '@ianesthesie-kit/redux';
import { useAppSelector } from '@/hooks';
import { selectCommChannelVerificationPostponed } from '@/modules/ui';
import { useEffect, useRef } from 'react';
import { AppDialogType } from '@/config';
import { useIsCommunicationEnabledOnHospital } from '@/modules/notification';
import { dialogsAllowedOnPage, selectIsAnyDialogOpen } from './util';
import { useCleanPathname } from '@ianesthesie-kit/core';

export const useCommunicationChannelVerificationChecker = () => {
  const isUserVerified = useIsVerified();
  const { showDialog } = useDialog();
  const pathname = useCleanPathname();
  const { emailVerified, emailCommunicationOptOut } = useCurrentPatient() ?? {};
  const verificationPostponed = useAppSelector(
    selectCommChannelVerificationPostponed
  );
  const isAnyDialogOpen = useAppSelector(selectIsAnyDialogOpen);
  const shownOnce = useRef(false);
  const isNotificationsEnabled = useIsCommunicationEnabledOnHospital();

  useEffect(() => {
    if (shownOnce.current || !isNotificationsEnabled || isAnyDialogOpen) {
      return;
    }
    const isAllowedPage = dialogsAllowedOnPage() && !!pathname;
    const emailNeedsVerification = !emailVerified && !emailCommunicationOptOut;
    let timeout: ReturnType<typeof setTimeout>;
    if (isAllowedPage && (!isUserVerified || emailNeedsVerification)) {
      timeout = setTimeout(() => {
        shownOnce.current = true;
        showDialog({
          severity: 'warning',
          dialogType: AppDialogType.COMM_CHANNEL_VERIFICATION,
          title: '',
          message: ''
        });
      }, 2000);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [
    isAnyDialogOpen,
    isNotificationsEnabled,
    verificationPostponed,
    showDialog,
    pathname,
    emailVerified,
    emailCommunicationOptOut,
    isUserVerified
  ]);
};
